import { Box } from "@mui/system";
import { AuthComp } from "../../../auth/AuthComp";
import { ADESIONECL, ESITICL, INVITISOLLECITICL, LOGIN } from "../../../global/urlMapping";
import { Redirect } from "../../tools/Redirect";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgress, Grid, Paper, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { ReactComponent as CandidaturaSpontanea } from "../../../resources/icone/candidatura_sponatanea.svg";
import { ReactComponent as InvitiSolleciti } from "../../../resources/icone/inviti_solleciti.svg";
import { ReactComponent as Consulting } from "../../../resources/icone/consulting.svg";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useEffect } from "react";
import { checkScreeningCLSelector } from "../../../modules/screeningColonRetto/selectors";
import { setMessaggioAction } from "../../../modules/messaggio/actions";
import { ERRORE_CHECK_SCREENING } from "../../../global/messaggioLabels";
import { checkScreeningCLAction } from "../../../modules/screeningColonRetto/actions";
import { isAuthenticatedSelector } from "../../../modules/auth/selectors";
import { IDLE, LOADING, SUCCEDED } from "../../../global/statusLabels";
import { postLoginSelector } from "../../../modules/postLogin/selectors";

export const ScreeningColonRetto = () => {
    const checkScreeningCL = useSelector(checkScreeningCLSelector)
    const isAuthenticated = useSelector(isAuthenticatedSelector)
    const postLogin = useSelector(postLoginSelector)

    const dispatch = useDispatch()
    useEffect(() => {
        window.scrollTo(0, 0)
        // mostro il messaggio informativo sulla possibilità di aderire o meno
        if (checkScreeningCL?.status === 400 && checkScreeningCL?.value?.params && checkScreeningCL?.value?.params?.length > 0) {
            if (checkScreeningCL?.value?.params[0] === "505") {
                dispatch(setMessaggioAction({ status: ERRORE_CHECK_SCREENING }))
            }
        }
    }, [checkScreeningCL, dispatch])
    useEffect(() => {
        if (isAuthenticated && postLogin?.status === SUCCEDED)
            dispatch(checkScreeningCLAction())
    }, [dispatch, isAuthenticated, postLogin])
    return (
        <AuthComp fallback={< Redirect link={LOGIN} />} >
            <Box className="bg"
                sx={{
                    flexGrow: 1,
                    overflow: 'hidden',
                    with: "100%"
                }}>
                <Box sx={{ x: 'auto' }}>
                    <Grid container wrap="nowrap" spacing={2}>
                        <Grid item xs zeroMinWidth>

                            <Box sx={{ width: "100%", height: "150px", display: "flex" }}>
                                <Typography
                                    component='h1'
                                    sx={{
                                        color: "#005397",
                                        margin: "auto",
                                        textAlign: "center",
                                        fontSize: { xs: "25px", md: "40px" },
                                        fontWeight: 700,
                                    }}
                                >
                                    Ecco cosa puoi fare per questa campagna di screening
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
                {

                    checkScreeningCL?.value !== LOADING && checkScreeningCL?.value !== IDLE &&
                    < Box sx={{ my: 4, mx: 'auto', paddingBottom: "20vh" }}>
                        <Grid container wrap="nowrap" spacing={2}>
                            <Grid item xs zeroMinWidth>
                                <Box
                                    sx={{
                                        width: "80%",
                                        margin: "auto",
                                        display: "flex",
                                        flexDirection: "column",
                                    }}
                                >
                                    {/*ADESIONE SPONTANEA */
                                        checkScreeningCL && checkScreeningCL.status === 200 &&
                                        <Paper
                                            elevation={6}
                                            sx={{
                                                minHeight: "150px",
                                                borderRadius: "20px",
                                                textDecoration: "none !important",
                                                display: "flex",
                                                width: { xs: "100%", md: "80%" },
                                                padding: "0px",
                                                margin: "auto",
                                                marginBottom: "42px"
                                            }}
                                            component={Link}
                                            to={ADESIONECL}
                                        >
                                            <Box
                                                sx={{
                                                    backgroundColor: "transparent",
                                                    minHeight: "100px",
                                                    width: "100%",
                                                    margin: "auto 0",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "space-between"

                                                }}
                                            >
                                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                    <CandidaturaSpontanea style={{ width: "100px", marginLeft: "20px", display: "flex", marginRight: "10px" }} />
                                                    <Typography
                                                        component='h2'
                                                        sx={{
                                                            color: "#005397",
                                                            fontSize: { xs: "20px", md: "25px" },
                                                            fontWeight: 700,

                                                        }}
                                                    >
                                                        {"Non hai ricevuto un invito? Aderisci tramite una candidatura spontanea"}
                                                    </Typography>
                                                </Box>
                                                <NavigateNextIcon sx={{ height: "40px", width: "42px", color: "#9A9A9A", marginRight: "20px" }} />
                                            </Box>
                                        </Paper>
                                    }
                                    <Paper
                                        elevation={6}
                                        sx={{
                                            minHeight: "150px",
                                            borderRadius: "20px",
                                            textDecoration: "none !important",
                                            display: "flex",
                                            width: { xs: "100%", md: "80%" },
                                            padding: "0px",
                                            margin: "auto",
                                            marginBottom: "42px"
                                        }}
                                        component={Link}
                                        to={INVITISOLLECITICL}
                                    >
                                        <Box
                                            sx={{
                                                backgroundColor: "transparent",
                                                minHeight: "100px",
                                                width: "100%",
                                                margin: "auto 0",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "space-between"
                                            }}
                                        >
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <InvitiSolleciti style={{ width: "100px", marginLeft: "20px", display: "flex", marginRight: "10px" }} />
                                                <Typography
                                                    component='h2'
                                                    sx={{
                                                        color: "#005397",
                                                        fontSize: { xs: "20px", md: "25px" },
                                                        fontWeight: 700,

                                                    }}
                                                >
                                                    {"Hai ricevuto un invito o un sollecito? Aderisci dalla lista dei tuoi inviti"}
                                                </Typography>
                                            </Box>
                                            <NavigateNextIcon sx={{ height: "40px", width: "42px", color: "#9A9A9A", marginRight: "20px" }} />
                                        </Box>
                                    </Paper>

                                    <Paper
                                        id="esiti"
                                        elevation={6}
                                        sx={{
                                            minHeight: "150px",
                                            borderRadius: "20px",
                                            textDecoration: "none !important",
                                            display: "flex",
                                            width: { xs: "100%", md: "80%" },
                                            padding: "0px",
                                            margin: "auto",
                                            marginBottom: "42px"
                                        }}
                                        component={Link}
                                        to={ESITICL}
                                    >
                                        <Box
                                            sx={{
                                                backgroundColor: "transparent",
                                                minHeight: "100px",
                                                width: "100%",
                                                margin: "auto 0",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "space-between"
                                            }}
                                        >
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <Consulting style={{ width: "100px", display: "flex", }} />
                                                <Typography
                                                    component='h2'
                                                    sx={{
                                                        color: "#005397",
                                                        fontSize: { xs: "20px", md: "25px" },
                                                        fontWeight: 700,
                                                    }}
                                                >
                                                    {"Consulta i tuoi esiti di primo livello"}
                                                </Typography>
                                            </Box>
                                            <NavigateNextIcon sx={{ height: "40px", width: "42px", color: "#9A9A9A", marginRight: "20px" }} />
                                        </Box>
                                    </Paper>

                                </Box>
                            </Grid>
                        </Grid>
                    </Box >
                }
                {
                    checkScreeningCL?.value === LOADING && checkScreeningCL?.value === IDLE &&
                    <CircularProgress sx={{ margin: "10% auto", display: 'flex', alignItems: "center" }} />
                }
            </Box >
        </AuthComp >
    );

}